import { memo } from "react";
import Box from "@mui/material/Box";
import Accordion from "ui/atoms/Accordion";
import PaymentMethodSummary from "../PaymentMethodSummary";
import DuplicatePaymentMethodButton from "../PaymentMethodSummary/DuplicatePaymentMethodButton";
import PaymentMethodDetail from "../PaymentMethodDetail";
import type { PaymentMethodProviderProps } from "../PaymentMethodProvider";
import PaymentMethodAccordionAction from "./PaymentMethodAccordionAction";
import usePaymentMethodUnsavedChanges from "./usePaymentMethodUnsavedChanges";

const PaymentMethodAccordion = (props: PaymentMethodProviderProps) => (
    <Accordion
        {...props}
        {...usePaymentMethodUnsavedChanges(props)}
        AccordionSummaryProps={{
            children: (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        width: '100%'
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0
                        }}
                    >
                        <PaymentMethodSummary />
                    </Box>
                    <DuplicatePaymentMethodButton />
                </Box>
            ),
            'aria-controls': `${props.paymentMethod!.name} content`,
            id: `${props.paymentMethod!.name} summary`
        }}
        AccordionActionsProps={{
            children: (
                <PaymentMethodAccordionAction />
            )
        }}
    >
        <PaymentMethodDetail />
    </Accordion>
);

export default memo(PaymentMethodAccordion);
